import globalService from "../../../service";
import request from "../utils/request";
import store from "../store";
import axios from "axios";
// 获取域名
export const getdomain = (params = {}) => {
  console.log(process.env.VUE_APP_BASEURL, "域名");
  if (!process.env.VUE_APP_BASEURL) return;
  let url = process.env.VUE_APP_BASEURL + "domain/info/queryDomainName";
  return request.post(url, {
    ...params
  });
};
// 发送消息
export const sendMsg = (params = {}) => {
  return request.post(`/api/user/msg`, {
    ...params
  });
};
// 确认订单
// export const sureOrder = (params = {}) => {
//   return request.post(`/api/user/msg`, {
//     ...params
//   });
// };
// // 查询游戏产品
// export const getGame = (params = {}) => {
//   return request.get(`/api/platform/games/list`, {
//     ...params
//   });
// };
// 发送订单消息
export const sendOrder = (params = {}) => {
  return request.post(`/api/platform/push/order/v2`, {
    ...params
  });
};
// 匹配会话
export const createChannel = (params = {}) => {
  if (
    store.state.dialogVisible ||
    store.state.dialogtime ||
    store.state.channeltime
  ) {
    store.commit("setState", { isload: false });
  } else {
    store.commit("setState", { isload: true });
  }

  params = {
    triggerId: store.state.triggerId,
    ...params
  };
  console.log("创建会话参数", params);
  return request.post(`/api/customer/channel`, {
    ...params
  });
};

// 新
export const getHistoryMessage = (params = {}, requestOptions = {}) => {
  const defaultParams = {
    userId: store.state.userId,
    beginTime: store.state.beginTime
  };

  return request.post(
    `/api/cusCustomer/newChatHistoryList`,
    {
      ...defaultParams,
      ...params
    },
    requestOptions
  );
};

export const createHistoryRequestCancellation = () => {
  const source = axios.CancelToken.source();
  return {
    requestOptions: {
      cancelToken: source.token,
      suppressUserError: true
    },
    cancel: () => source.cancel("history reconciliation scope changed")
  };
};
// 获取留言配合
export const getCustmessageMessage = (params = {}) => {
  return request.post(`/api/customer/queryLeaveMessage`, {
    ...params
  });
};
// 提交留言
export const saveCustmessageMessage = (params = {}) => {
  return request.post(`/api/cusCustomer/saveLeaveMessage`, {
    ...params
  });
};
// 结束会话
export const hangupChannel = (params = {}) => {
  params = {
    userId: store.state.userId,
    ...params
  };
  return request.post(`/api/customer/end`, {
    ...params
  });
};

// 上传客户信息
export const collectCustomerInfo = (params = {}) => {
  return request.post(`/api/customer/collectionUserToken`, {
    ...params
  });
};

// 上传设备信息
export const collectDeviceInfo = (params = {}) => {
  console.log(params);
  return request.post(`/api/common/information`, {
    ...params
  });
};

// 检查下载页存在与否
export const queryDownloadPages = (params = {}) => {
  return request.get(
    `/api/common/queryDownloadPages
`,
    {
      ...params
    }
  );
};

// 获取技能组
export const queryCusSkill = (params = {}) => {
  return request.post(`/api/cusCustomer/queryCusSkill`, {
    ...params
  });
};

//用户评论结果
export const querySatisfactionContent = (params = {}) => {
  return request.post(`/api/cusCustomer/querySatisfactionContent`, {
    ...params
  });
};

//评论配置信息
export const querySatisfaction = (params = {}) => {
  return request.post(`/api/cusCustomer/querySatisfaction`, {
    ...params
  });
};

//用户发出评论
export const addSatisfaction = (params = {}) => {
  return request.post(`/api/cusCustomer/addSatisfaction`, {
    ...params
  });
};

// 获取设备信息
export const getDeviceInfo = (params = {}) => {
  return request.post(`/api/cusServer/getDeviceInformation`, {
    ...params
  });
};

// 会话消息 掉消息 补充
export const getLostHistoryMessages = (params = {}) => {
  return request.post(`/api/customer/cusLeakageChatList`, {
    ...params
  });
};

//用户排队人数接口查询
export const queryCusQueue = (params = {}) => {
  return request.post(`/api/cusCustomer/queryCusQueue`, {
    ...params
  });
};

// 正在输入中
export const serviceEntering = (params = {}) => {
  return request.post(`/api/server/entering`, {
    ...params
  });
};

// 二次进入

export const getquerySessionValid = (params = {}) => {
  return request.post(`api/cusCustomer/querySessionValid`, {
    ...params
  });
};

// 退出排队
export const endQueue = (params = {}) => {
  return request.post(`api/customer/endQueue`, {
    ...params
  });
};

// 游戏平台
export const getGameList = () => {
  return request.get(`/api/common/queryCommonConfigs?configKey=GAME`);
};

// 充值方式
export const getRechargeList = () => {
  return request.get(`/api/common/queryCommonConfigs?configKey=RECHARGE`);
};

// 更新充值码
export const rechargeCode = (params = {}) => {
  return request.post(`api/cusCustomer/updateRechargeCode`, {
    ...params
  });
};

// 查询订单

export const getOrder = (params = {}) => {
  return request.post(`/api/recharge/find/order`, {
    ...params
  });
};

// 增加客服会话配置接口
export const queryServerConfig = (params = {}) => {
  return request.post(`/api/common/queryServerConfig`, {
    ...params
  });
};

// 查询订单接口
export const searchOrderList = (params = {}) => {
  return request.post(`/api/platform/search`, {
    ...params
  });
};

//确认订单

export const sureOrder = (params = {}) => {
  return request.post(`/api/platform/msg/order/confirm`, {
    ...params
  });
};
export default {
  ...globalService,
  createChannel,
  hangupChannel,
  getHistoryMessage,
  createHistoryRequestCancellation,
  collectCustomerInfo,
  queryCusSkill,
  querySatisfactionContent,
  querySatisfaction,
  addSatisfaction,
  collectDeviceInfo,
  queryCusQueue,
  getLostHistoryMessages,
  serviceEntering,
  getquerySessionValid,
  endQueue,
  rechargeCode,
  getOrder,
  queryServerConfig,
  getdomain,
  sendMsg,
  getCustmessageMessage,
  saveCustmessageMessage,
  searchOrderList,
  sendOrder,
  sureOrder,
  getGameList,
  getRechargeList,
  queryDownloadPages
};
